// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Teisaldatud ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Käsk',
  accControlKey: () => 'Sule',
  accPositionAfter: () => 'pärast',
  accPositionBefore: () => 'enne',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Vajutage pikalt klahvi ' +
    p['keyPressed'] +
    ' jatõstuklahve, seejärel kasutage ümberjärjestamiseks nooleklahve.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Sisestage täielik kuupäev nii: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Sisestage kuu ja aasta nii: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Rühm',
  chart_labelSeries: () => 'Sari',
  chart_labelValue: () => 'Väärtus',
  checkboxSet_requiredMessageDetail: () => 'Kohustuslik',
  checkbox_requiredMessageDetail: () => 'Kohustuslik',
  close: () => 'Sule',
  collection_noData: () => 'Kuvatavaid andmeid pole.',
  collection_selectAllRows: () => 'Vali kõik read',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vali rida ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Mittesorditav',
  collection_sortEnabled: () => 'Sorditav',
  confirmation: () => 'Kinnitus',
  datePicker_currentDate: () => 'Praegune kuupäev',
  datePicker_goToToday: () => 'Saate minna tänasele.',
  datePicker_label: () => 'Kuupäevavalija',
  datePicker_month: () => 'Kuu',
  datePicker_months: () => 'Kuud',
  datePicker_next: () => 'Järgmine',
  datePicker_nextDecade: () => 'Järgmine kümnend',
  datePicker_nextMonth: () => 'Järgmine kuu',
  datePicker_prev: () => 'Eelmine',
  datePicker_prevDecade: () => 'Eelmine kümnend',
  datePicker_prevMonth: () => 'Eelmine kuu',
  datePicker_restricted: () => 'Piiratud',
  datePicker_selected: () => 'Valitud',
  datePicker_today: () => 'Täna',
  datePicker_weekNum: (p: { NUM: string }) => 'Nädal ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Nädala number',
  datePicker_year: () => 'Aasta',
  datePicker_years: () => 'Aastad',
  error: () => 'Tõrge',
  expandableList_expandCollapseInstructionText: () =>
    'Kasutage laiendamiseks ja ahendamiseks nooleklahve',
  expandableList_groupCollapse: () => 'Ahendatud',
  expandableList_groupExpand: () => 'Laiendatud',
  filePicker_addFiles: () => 'Lisa failid',
  filePicker_dropzonePrimaryText: () => 'Pukseeri',
  filePicker_dropzoneSecondaryText: () => 'Valige fail või pukseerige see siia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Valige failid või pukseerige need siia',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Üles saate korraga laadida ühe faili',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'tundmatu',
  formControl_clear: () => 'Tühjenda',
  formControl_day: () => 'Päev',
  formControl_helpAvailable: () => 'Spikker on saadaval',
  formControl_hide: () => 'Peida',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Limiit ' +
    ((
      { one: new Intl.NumberFormat('et').format(p['CHARACTER_LIMIT']) + '-character' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('et').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('et').format(p['CHARACTER_LIMIT']) + '-character') +
    ' on täis.',
  formControl_loading: () => 'Laadimine',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Saate sisestada kuni ' + p['MAX_LENGTH'] + ' märki.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Järele on jäänud ' + p['CHARACTER_COUNT'] + ' märki.',
  formControl_month: () => 'Kuu',
  formControl_readOnly: () => 'Kirjutuskaitstud',
  formControl_requiredMessageDetail: () => 'Sisestage väärtus.',
  formControl_show: () => 'Kuva',
  formControl_year: () => 'Aasta',
  gantt_labelDate: () => 'Kuupäev',
  gantt_labelEnd: () => 'Lõpp',
  gantt_labelLabel: () => 'Silt',
  gantt_labelRow: () => 'Rida',
  gantt_labelStart: () => 'Algus',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Vastavat jaotist ei leitud.',
  indexer_keyboardInstructionText: () => 'Väärtuse valimiseks vajutage sisestusklahvi.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Vahemikus ' + p['FROM_SECTION'] + ' ja ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Topeltpuudutage ja hoidke žestirežiimi aktiveerimisekst ning seejärel lohistage väärtuse kohandamiseks üles või alla.',
  info: () => 'Teave',
  inputDateMask_date_cleared: () => 'Kuupäev on eemaldatud',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tühi',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Sisestage kuupäev, mis on ' + p['max'] + ' või varasem.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Sisestage kuupäev, mis on ' + p['min'] + ' või hilisem.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Sisestage saadaolev kuupäev.',
  inputDatePicker_instruction: () => 'Kalendri avamiseks vajutage tabeldusklahvi.',
  inputDatePicker_selectDate: () => 'Vali kuupäev',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Sisestage kuu ja kuupäev, mis on ' + p['max'] + ' või nendest varasem.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Sisestage kuu ja kuupäev, mis on ' + p['min'] + ' või nendest hilisem.',
  inputNumber_converterParseError: () => 'Sisestage number.',
  inputNumber_decrease: () => 'Vähendamine',
  inputNumber_increase: () => 'Suurendamine',
  inputPassword_hidden: () => 'Parool on peidetud',
  inputPassword_hide: () => 'Peida parool',
  inputPassword_show: () => 'Kuva parool',
  inputSensitiveText_hidden: () => 'Tundliku lomuga tekst on peidetud',
  list_msgFetchCompleted: () => 'Laaditud',
  list_msgFetchingData: () => 'Laadimine',
  list_suggestion: () => 'Soovitus',
  messageToast_allMessagesClosed: () => 'Kõik töölaua sõnumid on suletud.',
  message_close: () => 'Sule',
  message_confirmation: () => 'Õnnestus',
  message_error: () => 'Tõrge',
  message_info: () => 'Teave',
  message_navigationFromMessagesRegion: () =>
    'Sõnumite alasse liikumine. Eelmisele fookuses olnud elemendile tagasiliikumiseks vajutage klahvi F6.',
  message_navigationToMessagesRegion: () =>
    'Sõnumite alal on uusi sõnumeid. Viimatise sõnumi alale liikumiseks vajutage klahvi F6.',
  message_warning: () => 'Hoiatus',
  noData_message: () => 'Kuvatavaid üksusi pole',
  overflowItemLabel: () => 'Rohkem vahekaarte',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Pooleli',
  radio_helpForRadio: () => 'Raadionupu spikker',
  radio_requiredMessageDetail: () => 'Valige väärtus.',
  selectMultiple_apply: () => 'Rakenda',
  selectMultiple_back: () => 'Tagasi',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Valitud väärtuste esiletõstmiseks kasutage parem- ja vasaknoolt.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Valitud väärtuse eemaldamiseks vajutage tagasilükkeklahvi või klahvi Kustuta.',
  selectMultiple_selectedValues: () => 'Valitud väärtused',
  selectMultiple_showSelectedValues: () => 'Kuva ainult valitud väärtused.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Valitud on ' + p['VALUE_COUNT'] + ' väärtust.',
  select_addToList: () => 'Lisa loendisse',
  select_addToListAvailable: () => 'Loendisse lisamine on saadaval',
  select_moreSearchOptions: () => 'Veel otsingusuvandeid',
  select_moreSearchOptionsAvailable: () => 'Saadaval on veel otsingusuvandeid',
  select_noMatchesFound: () => 'Vasteid ei leitud.',
  select_oneMatchFound: () => 'Leiti üks vaste',
  select_requiredMessageDetail: () => 'Valige väärtus.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Leiti ' + p['TOTAL_SIZE'] + ' vastet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Leiti ' + p['TOTAL_SIZE'] + ' või rohkem vastet',
  selectorAll_deselectAll: () => 'Tühistage kogu valik',
  selectorAll_selectAll: () => 'Vali kõik',
  selector_selected: () => 'Märkeruut on märgitud',
  selector_unselected: () => 'Märkeruut pole märgitud',
  tabBarNavigationList_removeCueText: () => 'Eemaldatav',
  timeComponent_tooltipZoomIn: () => 'Suurenda',
  timeComponent_tooltipZoomOut: () => 'Vähenda',
  train_current: () => 'Praegune',
  train_message_type: () => 'Sõnumitüüp',
  train_not_visited: () => 'Pole külastatud',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Samm ' + p['currentStep'] + '/' + p['numberOfSteps'],
  train_visited: () => 'Külastatud',
  userAssistance_learnMore: () => 'Lisateave',
  userAssistance_required: () => 'Kohustuslik',
  vis_clearSelection: () => 'Tühjenda valik',
  vis_drillable: () => 'Süvitsiminekuks sobiv',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + '/' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Valikuraam',
  vis_marqueeZoomTooltip: () => 'Suumimisraam',
  vis_noData: () => 'Kuvatavaid andmeid pole',
  vis_panTooltip: () => 'Panoraami',
  vis_stateLoaded: () => 'Laaditud',
  vis_stateLoading: () => 'Laadimine',
  vis_stateSelected: () => 'Valitud',
  vis_stateUnselected: () => 'Valimata',
  warn: () => 'Hoiatus'
};
export default bundle;
